/* eslint-disable no-octal-escape */
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    suggestionContainer: {
      margin: '16px 48px',
      [theme.breakpoints.down('sm')]: {
        margin: '24px 16px',
      },
    },
    suggestionContent: {
      margin: '16px 0px',
    },
    suggestionList: {
      listStyle: 'none',
      // listStylePosition: 'inside',
      margin: '24px 0px 24px',
      // '& li': {
      //   display: 'flex',
      //   alignItems: 'flex-start',
      //   // marginBottom: 10,
      //   '&:before': {
      //     content: "'\u2022'",
      //     display: 'inline-block',
      //     width: '1em',
      //     fontSize: 22,
      //     marginTop: 7,
      //   },
      // },
    },
    title: {
      fontSize: 20,
      fontStyle: 'normal',
      fontWeight: 700,
      wordBreak: 'break-word',
    },
    suggestionSubtitle: {
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      wordBreak: 'break-word',
      lineHeight: 2,
    },
    suggestionListItem: {
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      wordBreak: 'break-word',
      lineHeight: 2,
      display: 'flex',
      alignItems: 'flex-start',
      '&:before': {
        content: "'\u2022'",
        display: 'inline-block',
        fontSize: 22,
        marginTop: -5,
        marginRight: 7,
      },
    },
    suggestionQuote: {
      fontSize: 16,
      fontStyle: 'italic',
      fontWeight: 600,
      wordBreak: 'break-word',
    },
    suggestionQuoteAuthor: {
      fontFamily: 'Poppins',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      wordBreak: 'break-word',
    },
  })
);

export default useStyles;
